document.addEventListener("turbolinks:load", function() {
  if (typeof _paq !== 'undefined') {
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
  }
});
